export default __webpack_public_path__ + "static/media/img_about-abg.87e01920.jpg";